// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../build/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../build/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-grey-25: #2a2f40;
  --color-grey-34: #3b4259;
  --color-grey-45: #4d5674;
  --color-grey-71: #919db4;
  --color-grey-72: #a8abb7;
  --color-grey-80: #afb9cc;
  --color-grey-91: #dce0e8;
  --color-grey-96: #eef1f6;
  --color-grey-98: #f6f8fa;
  --color-grey-99: #fafbfc;
  --color-grey-100: #ffffff;
  --color-primary-idel: #4563c7;
  --color-primary-hover: #2545b0;
  --color-primary-on-press: #1b3280;
  --color-danger-idel: #f66b7a;
  --color-danger-hover: #fc7483;
  --color-danger-on-press: #e56c79;
  --color-danger-disabled-bg: #f0dddf;
  --color-danger-disabled-text: #cc999e;
  --color-status-alert-96: #f66b7a;
  --color-status-alert-98: #fad7db;
  --color-status-alert-100: #fff5f6;
  --color-status-warning-100: #ffb302;
  --color-status-positive-80: #0acbbc;
  --color-status-positive-90: #84e5dd;
  --color-data-data: #3d9aee;
  --color-events-dark-rain: #94c7f6;
  --color-events-dark-irrigation: #0a5ef0;
  --color-events-dark-fertilization: #007a6a;
  --color-events-dark-water-treatment: #5c3a00;
  --color-events-dark-reserve-color: #6d0985;
  --color-events-light-rain: #e5eef5;
  --color-events-light-irrigation: #d3e2fe;
  --color-events-light-fertilization: #cef0f0;
  --color-events-light-water-treatment: #fcefd7;
  --color-events-light-reserve-color: #f0dcfc;
  --color-data-manipulator-active-bg: #d1e2ff;
  --color-disabled-64: #999ca3;
  --color-disabled-85: #d0d3d9;
  --color-disabled-95: #edeff2;
  --color-additional-active-dodger-blue: #3f83f7;
  --color-additional-active-carrot-orange: #ef9331;
  --color-additional-active-caribbean-green: #00c1a7;
  --color-additional-active-lipstic: #c30860;
  --color-additional-active-rose-bud-cherry: #85094d;
  --color-additional-active-indigo: #4251b9;
  --color-additional-active-sunglow: #ffdf2c;
  --color-additional-active-curious-blue: #20a2cf;
  --color-additional-active-punch: #de4836;
  --color-additional-active-mantis: #80d06a;
  --color-additional-active-electric-violet: #9a31ef;
  --color-additional-active-indigo-light: #5e70d1;
  --color-additional-active-bermuda-grey: #7188a1;
  --color-additional-active-tacao: #eeb48d;
  --color-additional-active-japonica: #dd776f;
  --color-additional-active-lavender: #b361de;
  --color-additional-active-lilac: #cd91cd;
  --color-additional-active-heathered-grey: #b8b99b;
  --color-additional-active-picasso: #ffea94;
  --color-additional-active-french-rose: #ee5279;
  --color-additional-archived-doger-blue: #88aae3;
  --color-additional-archived-carrot-orange: #d4b696;
  --color-additional-archived-caribbean-green: #9adbd2;
  --color-additional-archived-lipstic: #db9ab8;
  --color-additional-archived-rose-bud-cherry: #bb8ba5;
  --color-additional-archived-indigo: #a1a7d4;
  --color-additional-archived-sunglow: #dfd9b9;
  --color-additional-archived-curious-blue: #bcd9e3;
  --color-additional-archived-punch: #ad9e9c;
  --color-additional-archived-mantis: #b8c7b4;
  --color-additional-archived-electric-violet: #d8d1de;
  --color-additional-archived-indigo-light: #aaacb8;
  --color-additional-archived-bermuda-grey: #bdcee0;
  --color-additional-archived-tacao: #e7dbd3;
  --color-additional-archived-japonica: #e8c5c2;
  --color-additional-archived-lavender: #d0b4df;
  --color-additional-archived-lilac: #edd5ed;
  --color-additional-archived-heathered-grey: #dcdcd5;
  --color-additional-archived-picasso: #f2e4ab;
  --color-additional-archived-french-rose: #e9d5da;
}
.text-style-short-lables-16-regular {
  font-size: 16px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  text-decoration: none;
  text-transform: none;
}
.text-style-short-lables-16-semi-bold {
  font-size: 16px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-short-lables-14-regular {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  text-decoration: none;
  text-transform: none;
}
.text-style-short-lables-14-semi-bold {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-style: normal;
  line-height: 100%;
  text-decoration: none;
  text-transform: none;
}
.text-style-short-lables-12-regular {
  font-size: 12px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  text-decoration: none;
  text-transform: none;
}
.text-style-short-lables-12-semi-bold {
  font-size: 12px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-style: normal;
  line-height: 100%;
  text-decoration: none;
  text-transform: none;
}
.text-style-running-16-regular {
  font-size: 16px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  line-height: 140%;
  text-decoration: none;
  text-transform: none;
}
.text-style-running-14-regular {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  line-height: 140%;
  text-decoration: none;
  text-transform: none;
}
.text-style-running-14-semi-bold {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-style: normal;
  line-height: 140%;
  text-decoration: none;
  text-transform: none;
}
.text-style-running-14-bold {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 140%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-32-bold {
  font-size: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-32-light {
  font-size: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 300;
  font-style: normal;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-24-bold {
  font-size: 24px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-20-bold {
  font-size: 20px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-16-bold {
  font-size: 16px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-14-regular {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-14-semi-bold {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-14-bold {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-12-regular {
  font-size: 12px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-standard-12-bold {
  font-size: 12px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: none;
}
.text-style-titles-caps-14-regular {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: uppercase;
}
.text-style-titles-caps-14-bold {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: uppercase;
}
.text-style-titles-caps-14-bold-spaced {
  font-size: 14px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 112%;
  letter-spacing: 0.1em;
  text-decoration: none;
  text-transform: uppercase;
}
.text-style-titles-caps-13-bold {
  font-size: 13px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  letter-spacing: 0.07em;
  text-decoration: none;
  text-transform: uppercase;
}
.text-style-titles-caps-12-bold {
  font-size: 12px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  letter-spacing: 0.02em;
  text-decoration: none;
  text-transform: uppercase;
}
.text-style-titles-caps-12-regular {
  font-size: 12px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  line-height: 120%;
  text-decoration: none;
  text-transform: uppercase;
}
.text-style-titles-caps-11-bold {
  font-size: 11px;
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  letter-spacing: 0.01em;
  text-decoration: none;
  text-transform: uppercase;
}
.effect-style-01 {
  box-shadow: 0px 4px 10px #919db4;
}
.effect-style-02 {
  box-shadow: 0px 3px 6px #1c1d20;
}
.effect-style-05 {
  box-shadow:
    0px 30px 120px -20px #202227,
    0px 15px 24px -5px #3e434d;
}
.effect-style-05 {
  box-shadow:
    0px 30px 120px -20px #202227,
    0px 15px 24px -5px #3e434d;
}
`, "",{"version":3,"sources":["webpack://./../sciroot-clients-shared/styles/figma.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,0BAA0B;EAC1B,iCAAiC;EACjC,uCAAuC;EACvC,0CAA0C;EAC1C,4CAA4C;EAC5C,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,2CAA2C;EAC3C,6CAA6C;EAC7C,2CAA2C;EAC3C,2CAA2C;EAC3C,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,8CAA8C;EAC9C,gDAAgD;EAChD,kDAAkD;EAClD,0CAA0C;EAC1C,kDAAkD;EAClD,yCAAyC;EACzC,0CAA0C;EAC1C,+CAA+C;EAC/C,wCAAwC;EACxC,yCAAyC;EACzC,kDAAkD;EAClD,+CAA+C;EAC/C,+CAA+C;EAC/C,wCAAwC;EACxC,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;EACxC,iDAAiD;EACjD,0CAA0C;EAC1C,8CAA8C;EAC9C,+CAA+C;EAC/C,kDAAkD;EAClD,oDAAoD;EACpD,4CAA4C;EAC5C,oDAAoD;EACpD,2CAA2C;EAC3C,4CAA4C;EAC5C,iDAAiD;EACjD,0CAA0C;EAC1C,2CAA2C;EAC3C,oDAAoD;EACpD,iDAAiD;EACjD,iDAAiD;EACjD,0CAA0C;EAC1C,6CAA6C;EAC7C,6CAA6C;EAC7C,0CAA0C;EAC1C,mDAAmD;EACnD,4CAA4C;EAC5C,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE;;8BAE4B;AAC9B;AACA;EACE;;8BAE4B;AAC9B","sourcesContent":[":root {\n  --color-grey-25: #2a2f40;\n  --color-grey-34: #3b4259;\n  --color-grey-45: #4d5674;\n  --color-grey-71: #919db4;\n  --color-grey-72: #a8abb7;\n  --color-grey-80: #afb9cc;\n  --color-grey-91: #dce0e8;\n  --color-grey-96: #eef1f6;\n  --color-grey-98: #f6f8fa;\n  --color-grey-99: #fafbfc;\n  --color-grey-100: #ffffff;\n  --color-primary-idel: #4563c7;\n  --color-primary-hover: #2545b0;\n  --color-primary-on-press: #1b3280;\n  --color-danger-idel: #f66b7a;\n  --color-danger-hover: #fc7483;\n  --color-danger-on-press: #e56c79;\n  --color-danger-disabled-bg: #f0dddf;\n  --color-danger-disabled-text: #cc999e;\n  --color-status-alert-96: #f66b7a;\n  --color-status-alert-98: #fad7db;\n  --color-status-alert-100: #fff5f6;\n  --color-status-warning-100: #ffb302;\n  --color-status-positive-80: #0acbbc;\n  --color-status-positive-90: #84e5dd;\n  --color-data-data: #3d9aee;\n  --color-events-dark-rain: #94c7f6;\n  --color-events-dark-irrigation: #0a5ef0;\n  --color-events-dark-fertilization: #007a6a;\n  --color-events-dark-water-treatment: #5c3a00;\n  --color-events-dark-reserve-color: #6d0985;\n  --color-events-light-rain: #e5eef5;\n  --color-events-light-irrigation: #d3e2fe;\n  --color-events-light-fertilization: #cef0f0;\n  --color-events-light-water-treatment: #fcefd7;\n  --color-events-light-reserve-color: #f0dcfc;\n  --color-data-manipulator-active-bg: #d1e2ff;\n  --color-disabled-64: #999ca3;\n  --color-disabled-85: #d0d3d9;\n  --color-disabled-95: #edeff2;\n  --color-additional-active-dodger-blue: #3f83f7;\n  --color-additional-active-carrot-orange: #ef9331;\n  --color-additional-active-caribbean-green: #00c1a7;\n  --color-additional-active-lipstic: #c30860;\n  --color-additional-active-rose-bud-cherry: #85094d;\n  --color-additional-active-indigo: #4251b9;\n  --color-additional-active-sunglow: #ffdf2c;\n  --color-additional-active-curious-blue: #20a2cf;\n  --color-additional-active-punch: #de4836;\n  --color-additional-active-mantis: #80d06a;\n  --color-additional-active-electric-violet: #9a31ef;\n  --color-additional-active-indigo-light: #5e70d1;\n  --color-additional-active-bermuda-grey: #7188a1;\n  --color-additional-active-tacao: #eeb48d;\n  --color-additional-active-japonica: #dd776f;\n  --color-additional-active-lavender: #b361de;\n  --color-additional-active-lilac: #cd91cd;\n  --color-additional-active-heathered-grey: #b8b99b;\n  --color-additional-active-picasso: #ffea94;\n  --color-additional-active-french-rose: #ee5279;\n  --color-additional-archived-doger-blue: #88aae3;\n  --color-additional-archived-carrot-orange: #d4b696;\n  --color-additional-archived-caribbean-green: #9adbd2;\n  --color-additional-archived-lipstic: #db9ab8;\n  --color-additional-archived-rose-bud-cherry: #bb8ba5;\n  --color-additional-archived-indigo: #a1a7d4;\n  --color-additional-archived-sunglow: #dfd9b9;\n  --color-additional-archived-curious-blue: #bcd9e3;\n  --color-additional-archived-punch: #ad9e9c;\n  --color-additional-archived-mantis: #b8c7b4;\n  --color-additional-archived-electric-violet: #d8d1de;\n  --color-additional-archived-indigo-light: #aaacb8;\n  --color-additional-archived-bermuda-grey: #bdcee0;\n  --color-additional-archived-tacao: #e7dbd3;\n  --color-additional-archived-japonica: #e8c5c2;\n  --color-additional-archived-lavender: #d0b4df;\n  --color-additional-archived-lilac: #edd5ed;\n  --color-additional-archived-heathered-grey: #dcdcd5;\n  --color-additional-archived-picasso: #f2e4ab;\n  --color-additional-archived-french-rose: #e9d5da;\n}\n.text-style-short-lables-16-regular {\n  font-size: 16px;\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  line-height: 100%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-short-lables-16-semi-bold {\n  font-size: 16px;\n  font-family: 'Source Sans Pro';\n  font-weight: 600;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-short-lables-14-regular {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  line-height: 100%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-short-lables-14-semi-bold {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 600;\n  font-style: normal;\n  line-height: 100%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-short-lables-12-regular {\n  font-size: 12px;\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  line-height: 100%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-short-lables-12-semi-bold {\n  font-size: 12px;\n  font-family: 'Source Sans Pro';\n  font-weight: 600;\n  font-style: normal;\n  line-height: 100%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-running-16-regular {\n  font-size: 16px;\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  line-height: 140%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-running-14-regular {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  line-height: 140%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-running-14-semi-bold {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 600;\n  font-style: normal;\n  line-height: 140%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-running-14-bold {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 140%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-32-bold {\n  font-size: 32px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-32-light {\n  font-size: 32px;\n  font-family: 'Source Sans Pro';\n  font-weight: 300;\n  font-style: normal;\n  line-height: 100%;\n  letter-spacing: -0.01em;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-24-bold {\n  font-size: 24px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-20-bold {\n  font-size: 20px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-16-bold {\n  font-size: 16px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-14-regular {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-14-semi-bold {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 600;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-14-bold {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-12-regular {\n  font-size: 12px;\n  font-family: 'Source Sans Pro';\n  font-weight: 600;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-standard-12-bold {\n  font-size: 12px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: none;\n}\n.text-style-titles-caps-14-regular {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n.text-style-titles-caps-14-bold {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n.text-style-titles-caps-14-bold-spaced {\n  font-size: 14px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 112%;\n  letter-spacing: 0.1em;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n.text-style-titles-caps-13-bold {\n  font-size: 13px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  letter-spacing: 0.07em;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n.text-style-titles-caps-12-bold {\n  font-size: 12px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  letter-spacing: 0.02em;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n.text-style-titles-caps-12-regular {\n  font-size: 12px;\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  line-height: 120%;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n.text-style-titles-caps-11-bold {\n  font-size: 11px;\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n.effect-style-01 {\n  box-shadow: 0px 4px 10px #919db4;\n}\n.effect-style-02 {\n  box-shadow: 0px 3px 6px #1c1d20;\n}\n.effect-style-05 {\n  box-shadow:\n    0px 30px 120px -20px #202227,\n    0px 15px 24px -5px #3e434d;\n}\n.effect-style-05 {\n  box-shadow:\n    0px 30px 120px -20px #202227,\n    0px 15px 24px -5px #3e434d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
